import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import EmptyData from "../../Global/EmptyData";
import OrderColumn from "../../Global/OrderColumn";
import useSeasonalTheme from "./useSeasonalTheme";
import AddSeasonalTheme from "./AddSeasonalTheme";
import { ImageCard } from "../../Global/ImageCard";

const SeasonalTheme = () => {
  const {
    isLoading,
    isFetching,
    seasonalThemeList,
    showEditModal,
    seasonalThemeState,
    paginationOptions,
    handleEditColumnsClick,
    updateSeasonalThemeFields,
    handleDeleteModal,
    handleDelete,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handleEditAction,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
    imageData,
    showImageModal,
    deletable,
    closeImageModal,
    handleSelection,
  } = useSeasonalTheme();

  return (
    <div>
      <HeadingGroup
        title={"Seasonal Theme"}
        className={`pro-mb-4`}
        buttonTitle={seasonalThemeList?.create_permission && "Create"}
        handleClick={handleCreateClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={seasonalThemeState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: seasonalThemeState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {seasonalThemeList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={seasonalThemeList?.data?.result || []}
            uniqueID={"id"}
            fields={seasonalThemeList?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={
              <span className="material-symbols-outlined">delete</span>
            }
            handleSort={handleSort}
            getRow={getRow}
            clear={seasonalThemeState?.clearSelection}
            loading={isFetching}
            perpage={seasonalThemeState?.currentPageSize}
            assignable={false}
            handleEdit={handleEditAction}
            handleDelete={handleDeleteModal}
            deletable={seasonalThemeList?.delete_permission && deletable}
            editable={seasonalThemeList?.edit_permission}
            showCheckBox={
              seasonalThemeList?.delete_permission ||
              seasonalThemeList?.edit_permission
            }
            handleSelect={handleSelection}
          />
        )}

        {seasonalThemeList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={seasonalThemeState?.currentPage}
            totalPageCount={Math.ceil(
              seasonalThemeList?.data?.total_count /
                seasonalThemeState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === seasonalThemeState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={seasonalThemeState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure to delete the selected seasonal Theme ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetch={refetch}
              tableFields={seasonalThemeList?.fields || []}
              moduleId={seasonalThemeList?.module_id}
              updateData={updateSeasonalThemeFields}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={seasonalThemeState?.showCreateModal}
          handleClose={handleCreateClick}
          title={
            seasonalThemeState?.isEdit
              ? "Update Seasonal Theme"
              : "Add Seasonal Theme"
          }
          backdrop={"static"}
        >
          <AddSeasonalTheme
            refetch={refetch}
            handleCreateClick={handleCreateClick}
            isStickyFooter
          />
        </OffCanvasLayout>
        <ModalLayout
          show={showImageModal}
          handleClose={closeImageModal}
          backdrop="static"
        >
          <ImageCard data={imageData} handleClose={closeImageModal} />
        </ModalLayout>
      </div>
    </div>
  );
};

export default SeasonalTheme;
